/* eslint-disable no-console */
import Bugsnag, { Event } from '@bugsnag/js'
import BugsnagError, { Metadata } from './bugsnagError'

export class GenericEvent extends BugsnagError {
  payload?: Record<string, any>

  constructor(
    message: string,
    // eslint-disable-next-line default-param-last
    name = 'GenericEvent',
    payload?: Record<string, any>,
  ) {
    super(message)
    console.log(`GenericEvent payload: ${JSON.stringify(payload)}`)
    this.name = name
    this.payload = payload
  }

  getMetadata(): Metadata {
    if (this.payload) {
      return {
        dac: this.payload,
      }
    }
    return {}
  }
}

type Severity = 'info' | 'warning' | 'error'

export function logError(
  error: Error = new Error('Unknown Error'),
  severity: Severity = 'error',
) {
  Bugsnag.notify(error, (originalEvent: Event) => {
    // eslint-disable-next-line no-param-reassign
    originalEvent.severity = severity

    if (error instanceof BugsnagError) {
      for (const [section, metadata] of Object.entries(error.getMetadata())) {
        originalEvent.addMetadata(section, metadata)
      }
    }
  })
}

export function logEvent(
  message: string,
  eventName?: string,
  metadataObject: Record<string, any> = {},
) {
  const err = new GenericEvent(message, eventName, metadataObject)
  const severity: Severity = 'info'
  Bugsnag.notify(err, (originalEvent: Event) => {
    // eslint-disable-next-line no-param-reassign
    originalEvent.severity = severity
    const m = err.getMetadata()
    for (const [section, metadata] of Object.entries(m)) {
      originalEvent.addMetadata(section, metadata)
    }
  })
}
